/* UniCpoCart
----------------------------------------------------------*/

let UniCpoCart, cpoMakeInstance;

UniCpoCart = {
    flatpickrCfg:                      {},
    _init:                             function () {
        try {
            /* <fs_premium_only> */
            const {weekdays, months, scrollTitle, toggleTitle} = unicpo_cart_i18n.flatpickr;
            this.flatpickrCfg                                  = {
                locale: {
                    weekdays,
                    months,
                    daysInMonth:      [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                    firstDayOfWeek:   0,
                    ordinal:          (nth) => {
                        const s = nth % 100;
                        if (s > 3 && s < 21) return 'th';
                        switch (s % 10) {
                            case 1:
                                return 'st';
                            case 2:
                                return 'nd';
                            case 3:
                                return 'rd';
                            default:
                                return 'th';
                        }
                    },
                    rangeSeparator:   ' - ',
                    weekAbbreviation: 'Wk',
                    scrollTitle,
                    toggleTitle,
                    amPM:             ['AM', 'PM'],
                }
            };
            /* </fs_premium_only> */

            this.bindOnCartItemDuplicate();
            this.bindOnCartItemEdit();
            this.bindOnCartItemEditInline();
            this.bindOnCartItemSaveAfterInlineEdit();

        } catch (e) {
            console.error(e);
        }
    },
    bindOnCartItemDuplicate:           function () {
        /* <fs_premium_only> */
        const cpoCartObj = this;

        jQuery(document).on('click', '.uni-cpo-action-duplicate', function (e) {
            e.preventDefault();

            const $el    = jQuery(e.target);
            const elData = $el.data();
            const $form  = $el.parents('form');
            const nonce  = elData.nonce;
            const key    = elData.key;

            jQuery.ajax({
                type:       'GET',
                url:        unicpo_cart.cart_url + '?cpo_duplicate_cart_item=' + key + '&_nonce=' + nonce,
                dataType:   'html',
                beforeSend: function () {
                    cpoCartObj.block($form);
                    cpoCartObj.block(jQuery('div.cart_totals'));
                },
                success:    function (r) {
                    try {
                        cpoCartObj.update_wc_cart(r);
                    } catch (e) {
                        console.error(e);
                    }
                },
                complete:   function () {
                    cpoCartObj.unblock($form);
                    cpoCartObj.unblock(jQuery('div.cart_totals'));
                }
            });

        });
        /* </fs_premium_only> */
    },
    bindOnCartItemEdit:          function () {
        /* <fs_premium_only> */
        const cpoCartObj = this;

        jQuery(document).on('click', '.uni-cpo-action-edit', function (e) {
            e.preventDefault();

            const $el                 = jQuery(e.target);
            const elData              = $el.data();
            const $tr                 = $el.closest('tr');
            const security            = elData.nonce;
            const key                 = elData.key;
            const product_id          = elData.product_id;
            const action              = 'uni_cpo_cart_item_edit';

            const data = {action, key, product_id, security};

            jQuery.ajax({
                type:       'POST',
                url:        woocommerce_params.ajax_url,
                data,
                dataType:   'json',
                beforeSend: function () {
                    cpoCartObj.block($tr);
                },
                success:    function (r) {
                    if (r.success && r.data.redirect) {
                        window.location = r.data.redirect;
                        return;
                    }
                },
                complete:   function () {
                    cpoCartObj.unblock($tr);
                }
            });

        });
        /* </fs_premium_only> */
    },
    bindOnCartItemEditInline:          function () {
        /* <fs_premium_only> */
        const cpoCartObj = this;

        jQuery(document).on('click', '.uni-cpo-action-edit-inline', function (e) {
            e.preventDefault();

            const $el                 = jQuery(e.target);
            const elData              = $el.data();
            const $tr                 = $el.closest('tr');
            const security            = elData.nonce;
            const key                 = elData.key;
            const action              = 'uni_cpo_cart_item_edit_inline';
            const $variationContainer = $tr.find('.variation');
            const $editForm           = jQuery('<div class="cpo-cart-item-edit-form"></div>');
            const $saveBtn            = jQuery('<button class="cpo-cart-item-save"></button>');

            const data = {action, key, security};

            jQuery.ajax({
                type:       'POST',
                url:        woocommerce_params.ajax_url,
                data,
                dataType:   'json',
                beforeSend: function () {
                    $el.remove();
                    cpoCartObj.block($tr);
                },
                success:    function (r) {
                    try {
                        $editForm.append(r.data);
                        $saveBtn.text(unicpo_cart_i18n.saveChangesText);
                        $editForm.append($saveBtn);
                        $saveBtn.data('action', 'uni_cpo_cart_item_update_inline');
                        $saveBtn.data('key', key);
                        $saveBtn.data('security', security);
                        $variationContainer.replaceWith($editForm);
                    } catch (e) {
                        console.error(e);
                    }
                },
                complete:   function () {
                    cpoCartObj.unblock($tr);
                }
            });

        });
        /* </fs_premium_only> */
    },
    bindOnCartItemSaveAfterInlineEdit: function () {
        /* <fs_premium_only> */
        const cpoCartObj = this;

        jQuery(document).on('click', '.cpo-cart-item-save', function (e) {
            e.preventDefault();

            const $el      = jQuery(e.target);
            const data     = $el.data();
            const $form    = $el.closest('.cpo-cart-item-edit-form');
            const $options = $form.find('.cpo-cart-item-option:not(:disabled)');
            const $tr      = $el.closest('tr');
            let isValid    = true;

            data.data = {};
            jQuery.each($options, function (i, el) {
                const $el    = jQuery(el);
                const elType = this.type || this.tagName.toLowerCase();

                $el.parsley().validate();

                if ($el.parsley().isValid()) {
                    if ('checkbox' === elType) {
                        const name = el.name.replace('[]', '');
                        if (typeof data.data[name] !== 'undefined') {
                            return;
                        }
                        data.data[name] = jQuery.makeArray(data.data[name]);

                        jQuery('input[name="' + el.name + '"]:checked').each(function () {
                            data.data[name].push(this.value);
                        });
                    } else {
                        if ($el.hasClass('cpo-cart-item-option-multi')) {
                            data.data[el.name] = $el.val().split('|');
                        } else {
                            data.data[el.name] = $el.val();
                        }
                    }
                } else {
                    isValid = false;
                }
            });
            
            if (isValid) {
                jQuery.ajax({
                    type:       'POST',
                    url:        woocommerce_params.ajax_url,
                    data,
                    dataType:   'json',
                    beforeSend: function () {
                        cpoCartObj.block($tr);
                    },
                    success:    function (r) {
                        //console.log(r);
                    },
                    complete:   function () {
                        try {
                            cpoCartObj.unblock($tr);
                            cpoCartObj.getCartPage(data.key);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                });
            }
        });
        /* </fs_premium_only> */
    },
    block:                             function ($node) {
        const cpoCartObj = this;
        if (!cpoCartObj.is_blocked($node)) {
            $node.addClass('processing').block({
                message:    null,
                overlayCSS: {
                    background: '#fff',
                    opacity:    0.6
                }
            });
        }
    },
    getCartPage:                       function (key) {
        const cpoCartObj = this;
        const $form      = jQuery('.woocommerce-cart-form');
        jQuery.ajax({
            type:       'GET',
            url:        unicpo_cart.cart_url + '?cpo_edited_cart_item=1',
            dataType:   'html',
            beforeSend: function () {
                cpoCartObj.block($form);
                cpoCartObj.block(jQuery('div.cart_totals'));
            },
            success:    function (r) {
                //console.log(key);
                cpoCartObj.update_wc_cart(r, false, key);
            },
            complete:   function () {
                cpoCartObj.unblock($form);
                cpoCartObj.unblock(jQuery('div.cart_totals'));
            }
        });
    },
    is_blocked:                        function ($node) {
        return $node.is('.processing') || $node.parents('.processing').length;
    },
    position:                          function (el) {
        let $parent = el;
        let $list;
        let id;

        if (el.hasClass('parsley-error')) {
            $list = el.closest('.cpo-cart-item-option-wrapper').find('.parsley-errors-list');
        } else {
            $parent = jQuery('' + el.data('parsley-class-handler'));
            id      = el.data('parsley-multiple');
            $list   = jQuery('[id="parsley-id-multiple-' + id + '"]');
        }

        let width = $parent.outerWidth();

        setTimeout(function () {
            $list.position({
                of:        $parent,
                my:        'left top',
                at:        'left bottom',
                collision: 'none'
            });
            $list.css({
                'max-width': width,
                'opacity':   1
            });
        }, 300);
    },
    show_notice:                       function (html_element, $target) {
        if (!$target) {
            $target = jQuery('.woocommerce-cart-form');
        }
        $target.before(html_element);
    },
    unblock:                           function ($node) {
        $node.removeClass('processing').unblock();
    },
    update_wc_cart:                    function (html_str, preserve_notices, key = '') {
        const cpoCartObj  = this;
        const $html       = jQuery.parseHTML(html_str);
        const $new_form   = jQuery('.woocommerce-cart-form', $html);
        const $new_totals = jQuery('.cart_totals', $html);
        const $notices    = jQuery('.woocommerce-error, .woocommerce-message, .woocommerce-info', $html);

        // No form, cannot do this.
        if (jQuery('.woocommerce-cart-form').length === 0) {
            window.location.href = window.location.href;
            return;
        }

        // Remove errors
        if (!preserve_notices) {
            jQuery('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();
        }

        if ($new_form.length === 0) {
            // If the checkout is also displayed on this page, trigger reload instead.
            if (jQuery('.woocommerce-checkout').length) {
                window.location.href = window.location.href;
                return;
            }

            // No items to display now! Replace all cart content.
            const $cart_html = jQuery('.cart-empty', $html).closest('.woocommerce');
            jQuery('.woocommerce-cart-form__contents').closest('.woocommerce').replaceWith($cart_html);

            // Display errors
            if ($notices.length > 0) {
                cpoCartObj.show_notice($notices, jQuery('.cart-empty').closest('.woocommerce'));
            }
        } else {
            // If the checkout is also displayed on this page, trigger update event.
            if (jQuery('.woocommerce-checkout').length) {
                jQuery(document.body).trigger('update_checkout');
            }

            jQuery('.woocommerce-cart-form').replaceWith($new_form);
            jQuery('.woocommerce-cart-form').find('input[name="update_cart"]').prop('disabled', true);

            if ($notices.length > 0) {
                cpoCartObj.show_notice($notices);
            }

            cpoCartObj.update_cart_totals_div($new_totals);
        }

        jQuery(document.body).trigger('updated_wc_div');
    },
    update_cart_totals_div:            function (html_str) {
        jQuery('.cart_totals').replaceWith(html_str);
        jQuery(document.body).trigger('updated_cart_totals');
    }
};

//
cpoMakeInstance   = () => Object.create(UniCpoCart);
window.UniCpoCart = cpoMakeInstance();

// init
window.UniCpoCart._init();

//
window.Parsley.on('field:error', function () {
    window.UniCpoCart.position(this.$element);
});